import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import Logo from "/src/images/common/logo-3.png";
import MailImg from "/src/images/icon/mail.png"
const siteMetaData = json.siteMetadata

const Component = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header>
      <h1>
        <Link to={"/"} className={style.logo}>
          <img
            src={Logo}
            alt={siteMetaData.title}
            style={{ objectFit: "contain" }}
          />
        </Link>
      </h1>
      <nav className={style.nav}>
        <ul className={style.nav_list}>
          <li className={style.nav_item}>
            <Link to="/"><p>Home</p></Link>
          </li>
          <li className={style.nav_item}>
            <Link to={getPathFromTemplateType(3)}><p>Service</p></Link>
          </li>
          <li className={style.nav_item}>
            <Link to={"/staff"}><p>Staff</p></Link>
          </li>
          <li className={style.nav_item}>
            <Link to={"/voice"}><p>Voice</p></Link>
          </li>
          <li className={style.nav_item}>
            <Link to={"/company"}><p>Company</p></Link>
          </li>
          <li className={style.nav_item}>
            <Link to={getPathFromTemplateType(4)}><p>News</p></Link>
          </li>
          <li className={style.nav_item}>
            <Link to={"/recruit"}><p>Recruit</p></Link>
          </li>
          <li className={`${style.nav_item} ${style.contact}`}>
            <Link to={getPathFromTemplateType(6)}>
              <figure>
                <img src={MailImg} alt={"contact"}/>
                <span>Contact</span>
              </figure>
            </Link>
          </li>
        </ul>
      </nav>
      
      <button
        className={style.menu}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {!isOpen ? (
          <StaticImage
            src="../../images/icon/menu-open.svg"
            placeholder="none"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            style={{width: "25px"}}
            alt="開く"
          />
        ) : null}
      </button>
      {isOpen ? (
        <div className={style.sp_menu}>
          <button
            className={style.close_btn}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <StaticImage
              src="../../images/icon/menu-close.svg"
              placeholder="none"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              style={{width: "25px"}}
              alt="閉じる"
            />
          </button>
          <nav className={style.sp_nav}>
            <ul className={style.sp_nav_list}>
              <li className={style.sp_nav_item}>
                <Link to="/"><p>Home</p></Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={getPathFromTemplateType(3)}><p>Service</p></Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={"/staff"}><p>Staff</p></Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={"/voice"}><p>Voice</p></Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={"/company"}><p>Company</p></Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={getPathFromTemplateType(4)}><p>News</p></Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={"/recruit"}><p>Recruit</p></Link>
              </li>

              <li className={style.sp_nav_item}>
                <Link to={getPathFromTemplateType(5)}>
                  Plivacy Policy
                </Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={getPathFromTemplateType(6)}><p>Contact</p></Link>
              </li>

            </ul>

          </nav>
        </div>
      ) : null}
    </header>
  )
}

export default Component
